























































import { Component, Vue, Prop } from "vue-property-decorator";
import { UserLoginStats } from "../api";
import UserFilter from "./UserFilter.vue";
import moment from "moment";
import ImpersonateButton from "./ImpersonateButton.vue";

@Component({
  components: { UserFilter, ImpersonateButton },
  filters: {
    date(d: Date): string {
      if (d.toString() == `0001-01-01T00:00:00Z`) return `Nooit`;
      return moment(d).fromNow();
    },
  },
})
export default class UserStatsTable extends Vue {
  @Prop({ required: true })
  value!: UserLoginStats[];

  stats: UserLoginStats[] = [];
  search = "";

  headers = [
    { text: this.t("representeeId"), value: "representee_id" },
    { text: this.t("organisationName"), value: "organisation_name" },
    { text: this.t("id"), value: "id" },
    { text: this.t("firstName"), value: "first_name" },
    { text: this.t("lastName"), value: "last_name" },
    { text: this.t("emailAddress"), value: "email_address" },
    { text: this.t("lastLogin"), value: "last_login" },
    { text: this.t("timesLoggedIn"), value: "times_logged_in" },
    { text: "", value: "" },
  ];

  pagination = {
    descending: true,
    sortBy: "last_login",
  };

  rowsPerPageItems = [
    15,
    25,
    50,
    { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
  ];

  private t(key: string): string {
    return this.$t("base.components.userStatsTable." + key).toString();
  }

  openOrg(item: UserLoginStats): void {
    this.$compenda.getRelation(item.representee_id);
  }

  openContact(item: UserLoginStats): void {
    this.$compenda.getRelation(item.id);
  }
}
